import { defineComponent as _defineComponent } from 'vue'
import {
    emptyUseCaseContent,
    UseCase,
    UseCaseContent,
    UseCasesTextContent
} from '@/ui/microtrend/use-cases/use-cases.types'
import { ref, watch } from 'vue'
import SavedUseCases from '@/ui/microtrend/use-cases/saved-use-cases/saved-use-cases.vue'
import UseCaseForm from '@/ui/microtrend/use-cases/use-case-form/use-case-form.vue'
import AiGeneratedUseCase from '@/ui/microtrend/use-cases/ai-generated-use-case/ai-generated-use-case.vue'

interface Props {
  explain: (industry: string) => Promise<string>
  industries: Array<string>
  initialUseCases: UseCase[]
  useCasesTextContent: UseCasesTextContent
  createUseCase: (content: UseCaseContent) => Promise<UseCase>
  updateUseCase: (id: string, content: UseCaseContent) => Promise<UseCase>
  deleteUseCase: (useCase: UseCase) => Promise<void>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'use-cases',
  props: {
    explain: null,
    industries: null,
    initialUseCases: null,
    useCasesTextContent: null,
    createUseCase: null,
    updateUseCase: null,
    deleteUseCase: null
  },
  setup(__props: any) {

const props = __props as { explain: (industry: string) => Promise<string>, industries: Array<string>, initialUseCases: UseCase[], useCasesTextContent: UseCasesTextContent, createUseCase: (content: UseCaseContent) => Promise<UseCase>, updateUseCase: (id: string, content: UseCaseContent) => Promise<UseCase>, deleteUseCase: (useCase: UseCase) => Promise<void> }



const activeTab = ref<number>(0)
const useCases = ref<UseCase[]>([])
const formData = ref<UseCaseContent>(emptyUseCaseContent())
const editingUseCase = ref<UseCase | null>(null)
const activeUseCaseId = ref<string | undefined>(undefined)

function replaceUseCase (useCase: UseCase) {
    return useCases.value.map(uc => {
        if (useCase.id === uc.id) {
            return useCase
        }

        return uc
    })
}

function formTabTitle (): string {
    if (editingUseCase.value === null) {
        return props.useCasesTextContent.tabTitles.create
    }

    return props.useCasesTextContent.tabTitles.edit
}

function resetForm () {
    editingUseCase.value = null
    formData.value = emptyUseCaseContent()
}

async function submit (content: UseCaseContent): Promise<void> {
    let useCase: UseCase
    if (editingUseCase.value !== null) {
        useCase = await props.updateUseCase(editingUseCase.value.id, content)
        useCases.value = replaceUseCase(useCase)
    } else {
        useCase = await props.createUseCase(content)
        useCases.value.push(useCase)
    }

    resetForm()
    activeTab.value = 2
    activeUseCaseId.value = useCase.id
}

async function cancel (): Promise<void> {
    activeTab.value = 2
    resetForm()
}

async function handleUseCaseDeletion (useCase: UseCase): Promise<void> {
    await props.deleteUseCase(useCase)

    useCases.value = useCases.value.filter(uc => uc.id !== useCase.id)
}

async function showCreateFormWithPrefilledInputs (content: UseCaseContent): Promise<void> {
    formData.value = content

    activeTab.value = 1
}

async function editUseCase (useCase: UseCase): Promise<void> {
    editingUseCase.value = { ...useCase }

    formData.value = {
        title: useCase.title,
        text: useCase.text
    }

    activeTab.value = 1
}

watch(
    () => props.initialUseCases,
    (newValue) => {
        useCases.value = newValue
    },
    { immediate: true }
)

return { __sfc: true,props, activeTab, useCases, formData, editingUseCase, activeUseCaseId, replaceUseCase, formTabTitle, resetForm, submit, cancel, handleUseCaseDeletion, showCreateFormWithPrefilledInputs, editUseCase, SavedUseCases, UseCaseForm, AiGeneratedUseCase }
}

})